import styled from 'styled-components';
import { body2, spacing, colors, fontWeights } from 'ui/theme';

export const Banner = styled.div`
  ${body2}
  display: flex;
  justify-content: center;
  padding: ${spacing.threeQuarter};
  background-color: ${colors.grey5};
`;

export const PreviewBannerText = styled.div<{ color: string }>`
  display: flex;
  color: ${({ color }) => color};
  margin-left: ${spacing.half};
`;

export const VariantName = styled.div`
  font-weight: ${fontWeights.semiBold};
`;
